import { useMemo, memo } from 'react'
import TextField from "@mui/material/TextField"
import { styled } from '@mui/material'

export const Item = styled('div')(({ theme }) => ({
    ...theme.typography.body2,
    "& .MuiFormHelperText-root": { textAlign: 'right' },
    textAlign: 'left',
    color: theme.palette.text.secondary,
}))

const InputTextField = ({ touched, errors, name, fullWidth = true, displayEmpty, ...props }) => {

    const { helperValue, error } = useMemo(() => {
        // Extrair o índice do name (ex: produto[0] -> 0)
        const match    = name.match(/^(\w+)\[(\d+)\]$/);
        const baseName = match ? match[1] : name; // Nome base (ex: 'produto' ou 'dataNascimento')
        const index    = match ? parseInt(match[2], 10) : null; // Índice (ex: 0)
    
        // Verifica se errors contém a chave baseName
        const hasError = errors && typeof errors === "object" && baseName in errors;
    
        // Verifica se touched contém a chave baseName
        const isTouched = touched && typeof touched === "object" && baseName in touched ? touched[baseName] : false;
    
        // Obtém o erro correto, seja para array ou valor único
        let currentError;

        if (hasError) {
            if (index !== null && Array.isArray(errors[baseName]) && errors[baseName].length > index) {
                currentError = errors[baseName][index]; // Pega erro do índice específico
            } else if (typeof errors[baseName] === "string") {
                currentError = errors[baseName]; // Pega erro normal (quando não é array)
            }
        }
    
        // Verifica se deve exibir a mensagem de erro
        const hasHelperValue = Boolean(currentError) && isTouched;
    
        return {
            helperValue: hasHelperValue ? currentError : " ",
            error: hasHelperValue
        };
    }, [name, errors, touched])
    

    return (
        <TextField
            name={name}
            fullWidth={fullWidth}
            error={error}
            helperText={helperValue}
            {...props}
        />
    )
}

export default memo(InputTextField)
